import { FIELD_TYPE } from "../../type/fileType";
import { ROLES } from "../../type/roles";

const { INPUT, COMBO_BOX, SELECT } = FIELD_TYPE;

const renderRole = (role) => {
  switch (role) {
    case ROLES.ROLE_ADMIN:
      return <div style={{ color: "red" }}>Quản trị viên</div>;
    case ROLES.ROLE_LEADER:
      return <div style={{ color: "blue" }}>Trưởng nhóm</div>;
    case ROLES.ROLE_STAFF:
      return <div style={{ color: "gray" }}>Thành viên</div>;
    default:
      return <div>{role}</div>;
  }
};

const columnsTableList = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    render: (text, record, index) => index + 1,
    align: "center",
  },

  {
    title: "Tên tài khoản",
    dataIndex: "username",
    key: "username",
  },
  {
    title: "Tên người dùng",
    dataIndex: "fullName",
    key: "fullName",
  },
  {
    title: "Vai trò",
    dataIndex: "roles",
    key: "roles",
    align: "center",
    render: (text, record) => {
      return (
        <div>
          {record.roles.map((item) => (
            <p key={item}>{renderRole(item)}</p>
          ))}
        </div>
      );
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    align: "center",
  },
];

const dataAddUser = [
  {
    type: INPUT,
    label: "Tài khoản",
    name: "username",
    rules: [{ required: true, message: "Chưa nhập tài khoản" }],
    key: "username",
  },
  {
    type: INPUT,
    label: "Tên người dùng",
    name: "fullName",
    rules: [{ required: true, message: "Chưa nhập tên" }],
    key: "fullName",
  },
  {
    type: COMBO_BOX,
    label: "Vai trò",
    name: "roles",
    rules: [{ required: true, message: "Chưa chọn vai trò" }],
    options: [
      { label: "Quản trị", value: ROLES.ROLE_ADMIN },
      { label: "Leader", value: ROLES.ROLE_LEADER },
      { label: "Thành viên", value: ROLES.ROLE_STAFF },
    ],
    key: "roles",
  },
  {
    type: INPUT,
    label: "Mật khẩu",
    name: "password",
    rules: [{ required: true, message: "Chưa nhập mật khẩu" }],
    key: "password",
  },
  {
    type: SELECT,
    label: "Leader",
    name: "leadTeamUserId",
    key: "leadTeamUserId",
  },
];

const userSearch = [
  {
    type: INPUT,
    label: "Tên người dùng",
    name: "keyword",
  },
];

export { columnsTableList, dataAddUser, userSearch };
